import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../API/auth.service';

export const studentGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getUser();

  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  if (user.userRoles.filter(role => role.role === 'STUDENT').length > 0) {
    return true;
  }

  router.navigate(['/']);
  return false;
};
